export const API = 'api';
export const DB = 'db';